import React, { Component } from 'react'
import SwipeListener from 'swipe-listener'
import VideoPlayer from './carousel-video.js'

class Carousel extends Component {
  constructor (props) {
    super(props)

    this.state = {
      activeSlide: 0
    }
    this.inView = this.inView.bind(this)
    this.handleSwipeEvent = this.handleSwipeEvent.bind(this)
    this.changeSlide = this.changeSlide.bind(this)
    this.showNextSlide = this.showNextSlide.bind(this)
    this.showPrevSlide = this.showPrevSlide.bind(this)
    this.setTimer = this.setTimer.bind(this)
    this.clearTimer = this.clearTimer.bind(this)
    this.resetTimer = this.resetTimer.bind(this)
  }

  componentDidMount () {
    const carouselSlide = document.getElementsByClassName('carousel__slide')[0]
    SwipeListener(carouselSlide)
    carouselSlide.addEventListener('swipe', this.handleSwipeEvent)
    document.addEventListener('scroll', this.inView)
  }

  componentWillUnmount () {
    const carouselSlide = document.getElementsByClassName('carousel__slide')[0]
    carouselSlide.removeEventListener('swipe', this.handleSwipeEvent)
    document.removeEventListener('scroll', this.inView)
    this.clearTimer()
  }

  inView () {
    const slide = document.getElementsByClassName('carousel__slide')[0]

    if (slide.getBoundingClientRect().bottom <= window.innerHeight) {
      this.setTimer()
      document.removeEventListener('scroll', this.inView)
    }
  }

  handleSwipeEvent (event) {
    const directions = event.detail.directions
    if (directions.left) {
      this.showNextSlide()
    } else if (directions.right) {
      this.showPrevSlide()
    }
  }

  setTimer () {
    this.interval = setInterval(this.showNextSlide, this.props.interval || 8000)
  }

  clearTimer () {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  resetTimer () {
    this.clearTimer()
    this.setTimer()
  }

  changeSlide (event) {
    event.preventDefault()
    const slideId = event.target.dataset.slide

    this.setState({
      activeSlide: Number(slideId)
    })

    this.resetTimer()
  }

  showNextSlide () {
    let nextSlide = this.state.activeSlide + 1

    if (nextSlide >= this.props.media.length) {
      nextSlide = 0
    }

    this.setState({
      activeSlide: nextSlide
    })

    this.resetTimer()
  }

  showPrevSlide () {
    let prevSlide = this.state.activeSlide - 1

    if (prevSlide < 0) {
      prevSlide = this.props.media.length - 1
    }

    this.setState({
      activeSlide: prevSlide
    })

    this.resetTimer()
  }

  render () {
    const { activeSlide } = this.state
    const { media, extraClass } = this.props
    const classes = 'carousel__item'

    return (
      <div className={extraClass ? `carousel ${extraClass}` : 'carousel'}>
        <div className='carousel__slide'>
          {media.map((item, index) => (
            item.type === 'image'
              ? (<div
                key={item.id}
                className={activeSlide === index ? `${classes} ${classes}--active` : classes}
              >
                <img src={item.src} />
                {(item.externalLink || item.internalLink) &&
                  <a
                    className={item.externalLink ? 'link' : 'internal-link'}
                    href={item.externalLink || item.internalLink}
                    target={item.externalLink ? '_blank' : '_self'}
                    rel='noreferrer noopener'
                  />
                }
              </div>)
              : (<VideoPlayer
                key={item.id}
                classes={classes}
                index={index}
                activeSlide={activeSlide}
                clearTimer={this.clearTimer}
                resetTimer={this.resetTimer}
                item={item}
              />)
          ))}
        </div>
        <ul className='carousel__indicator'>
          {media.map((item, index) => (
            <li
              key={item.id}
              className={activeSlide === index ? 'active' : ''}
              data-slide={index}
              onClick={this.changeSlide}
            />
          ))}
        </ul>
      </div>
    )
  }
}

export default Carousel



// WEBPACK FOOTER //
// ./src/components/carousel.js